import { render, staticRenderFns } from "./SingleTag.vue?vue&type=template&id=0ec64b7c&scoped=true&"
import script from "./SingleTag.vue?vue&type=script&lang=js&"
export * from "./SingleTag.vue?vue&type=script&lang=js&"
import style0 from "./SingleTag.vue?vue&type=style&index=0&id=0ec64b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec64b7c",
  null
  
)

export default component.exports